/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_View_StorefrontInputs */

const en_profile_view_storefront = /** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Storefront`)
};

const es_profile_view_storefront = /** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver Tienda`)
};

const fr_profile_view_storefront = /** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la vitrine`)
};

const de_profile_view_storefront = /** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront ansehen`)
};

const id_profile_view_storefront = /** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat Etalase`)
};

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const ja_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const zh_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const ar_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const it_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const ru_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const pt_profile_view_storefront = en_profile_view_storefront;

/** @type {(inputs: Profile_View_StorefrontInputs) => LocalizedString} */
const ko_profile_view_storefront = en_profile_view_storefront;

/**
* | output |
* | --- |
* | "View Storefront" |
*
* @param {Profile_View_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_view_storefront = /** @type {((inputs?: Profile_View_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_View_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_view_storefront(inputs)
	if (locale === "es") return es_profile_view_storefront(inputs)
	if (locale === "fr") return fr_profile_view_storefront(inputs)
	if (locale === "de") return de_profile_view_storefront(inputs)
	if (locale === "ja") return ja_profile_view_storefront(inputs)
	if (locale === "zh") return zh_profile_view_storefront(inputs)
	if (locale === "ar") return ar_profile_view_storefront(inputs)
	if (locale === "id") return id_profile_view_storefront(inputs)
	if (locale === "it") return it_profile_view_storefront(inputs)
	if (locale === "ru") return ru_profile_view_storefront(inputs)
	if (locale === "pt") return pt_profile_view_storefront(inputs)
	return ko_profile_view_storefront(inputs)
});